<template>
  <div class="w-100 p-2 mt-2">
    <page-header>
      <b-icon-box class="mr-1"></b-icon-box>
      {{ $t('page.title.fun_packages') }}
      <template v-slot:right>
        <b-button @click="addNew()" size="sm" variant="success">
          {{ $t('btn.add_new') }}
        </b-button>
      </template>
    </page-header>
    <page-card>
      <template v-slot:header>
        {{ $t('title.filters') }}
      </template>
      <template v-slot:content>
        <div class="questions sygni-grid">
          <div class="row">
            <div class="col-4">
              <filter-input
                  :filter-query="filterQuery"
                  filter-name="name"
                  :label="$t('filters.label.package_name')"
                  :placeholder="$t('filters.placeholder.package_name')">
              </filter-input>
            </div>
            <div class="col-4">
              <filter-input-with-operator
                  :filter-query="filterQuery"
                  :operator-options="filterOptions.comparisonOperator"
                  :operator-multiple="false"
                  :default-operator="{value: 'eq', text: $t('operator.equales')}"
                  :restrict-input="true"
                  restriction-type="decimals"
                  filter-name="quantity"
                  :label="$t('filters.label.coin_quantity')"

              >
              </filter-input-with-operator>
            </div>
            <div class="col-4">
              <filter-input-with-operator
                  :filter-query="filterQuery"
                  :operator-options="filterOptions.comparisonOperator"
                  :operator-multiple="false"
                  :default-operator="{value: 'eq', text: $t('operator.equales')}"
                  :restrict-input="true"
                  restriction-type="decimals"
                  filter-name="totalPrice"
                  :label="$t('filters.label.price')"
              >
              </filter-input-with-operator>
            </div>
          </div> <!-- #row-->
          <div class="row">
            <div class="col-4">
              <filter-date-range-picker
                  :filter-query="filterQuery"
                  :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                  :auto="true"
                  :linked="false"
                  :time-picker="true"
                  filter-name="createdAt"
                  open-direction="left"
                  :label="$t('filters.label.created_at')">
              </filter-date-range-picker>
            </div>
            <div class="col-4">
              <filter-date-range-picker
                  :filter-query="filterQuery"
                  :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                  :auto="true"
                  :linked="false"
                  :time-picker="true"
                  filter-name="updatedAt"
                  open-direction="left"
                  :label="$t('filters.label.updated_at')">
              </filter-date-range-picker>
            </div>
          </div>
        </div> <!-- #card questions sygni-grid-->
      </template>
      <template v-slot:footer>
        <b-button @click="resetFilters()" variant="secondary">{{$t('filters.btn.clear')}}</b-button>
        <b-button @click="applyFilters()" variant="primary">{{$t('filters.btn.apply')}}</b-button>
      </template>
    </page-card>
    <page-card>
      <template v-slot:header>
        {{ $t('page.list' )}}
      </template>
      <template v-slot:content>
        <div class="row mt-2">
          <div class="col-12">
            <grid-pagination :total-count="totalCount"
                             :per-page="perPage"
                             :current-page="currentPage"
                             @load-items="paginationReload"></grid-pagination>

            <div class="table-responsive sygni-grid">
              <b-table striped show-empty
                       :empty-text="$t('table.no_results')"
                       :busy="isBusy"
                       hover
                       head-variant="dark"
                       outlined
                       :sort-by.sync="orderColumn"
                       :sort-desc.sync="orderDirection"
                       :no-local-sorting="true"
                       :items="items"
                       :fields="fields">

                <template #head(alias)="data">
                  <b-checkbox
                      @change="toggleAllCheckboxes($event, data)">
                  </b-checkbox>
                </template>

                <template #cell(unitPrice)="data">
                  <div>{{data.value | numberFormat}}</div>
                </template>

                <template #cell(totalPrice)="data">
                  <div>{{data.value | numberFormat}}</div>
                </template>

                <template #cell(id)="data">
                  <div>{{data.value | shortId}}</div>
                </template>

                <template #cell(createdAt)="data">
                  <div class="table-flag--wrapper">
                    <div>{{ data.item.createdAt | date }}</div>
                  </div>
                </template>

                <template #cell(updatedAt)="data">
                  <div class="table-flag--wrapper">
                    <div>{{ data.item.updatedAt | date }}</div>
                  </div>
                </template>

                <template #cell(categories)="data">
                  <div class="table-categories--wrapper" v-for="(cat, index) in data.value" :key="index">
                    <b-badge variant="light">{{ cat }}</b-badge>
                  </div>
                </template>

                <template #cell(isActive)="data">
                  <b-badge pill variant="success" v-if="data.value">{{$t('state.active')}}</b-badge>
                  <b-badge pill variant="danger" v-if="!data.value">{{$t('state.disabled')}}</b-badge>
                </template>

                <template #cell(answers)="data">
                  <div class="table--answers">
                    <div v-for="(ans, index) in data.value" :key="index">
                      <b-badge :variant="data.item.correctAnswer === (index+1) ? 'success' : ''">
                        {{ ans }}
                      </b-badge>
                    </div>
                  </div>
                </template>

                <template #cell(actions)="data">
                  <div class="table-action--cell">
                    <b-button :variant="data.item.isActive ? 'danger' : 'success'" size="sm"
                              @click="deleteItem(data.item)">
                      {{data.item.isActive ? $t('btn.disable') : $t('btn.enable')}}
                    </b-button>
                  </div>
                </template>

                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>

              </b-table>
            </div> <!-- #table-responsive-->

            <grid-pagination :total-count="totalCount"
                             :per-page="perPage"
                             :current-page="currentPage"
                             @load-items="paginationReload"></grid-pagination>

          </div>
        </div>
      </template>
    </page-card>
  </div>
</template>


<script>

import axios from "axios";
import FilterInputWithOperator from "../../../components/grid/filters/FilterInputWithOperator";
import FilterInput from "../../../components/grid/filters/FilterInput";
import FilterDateRangePicker from "../../../components/grid/filters/FilterDateRangePicker";
import GridMixin from "../../../components/grid/GridMixin";
import Vue from "vue";
import PackageAddModal from "../components/PackageAddModal";
import GridPagination from "../../../components/grid/grid-pagination/GridPagination";
import PageCard from "../../../components/page/PageCard";
import PageHeader from "../../../components/page/PageHeader";


export default {
  mixins: [GridMixin],
  components: {
    PageHeader,
    PageCard,
    FilterInput,
    FilterInputWithOperator,
    FilterDateRangePicker,
    GridPagination
  },
  data() {
    return {
      gridGetUrl: '/api/purchase/fun-coin-package',
      showDeleted: false,
      orderColumn: null,
      orderDirection: true,
      fields: [
        {key: 'id', label: this.$t('table.header.id')},
        {key: 'name', label: this.$t('table.header.package_name')},
        {key: 'quantity', label: this.$t('table.header.coin_quantity'), sortable: true},
        {key: 'totalPrice', label: this.$t('table.header.price'), sortable: true},
        {key: 'totalPriceCurrency', label: this.$t('table.header.currency'), sortable: true},
        {key: 'unitPrice', label: this.$t('table.header.unit_price'), sortable: true},
        {key: 'isActive', label: this.$t('table.header.status'), sortable: true},
        {key: 'createdAt', label: this.$t('table.header.created_at'), sortable: true},
        {key: 'updatedAt', label: this.$t('table.header.updated_at'), sortable: true},
        {key: 'actions', label: this.$t('table.header.actions'),  sortable: false},
      ],
      selectOptions: {
        bulkActions: [
          {value: null, text: this.$t('table.bulk.actions')},
          {value: 'delete', text: this.$t('table.bulk.actions.delete')},
        ],
      },
      filterOptions: {
        comparisonOperator: [
          {value: 'eq', text: this.$t('operator.equales')},
          {value: 'gte', text: this.$t('operator.greater_then')},
          {value: 'lte', text: this.$t('operator.lower_than')},
          {value: 'btw', text: this.$t('operator.between')},
        ]
      },
      items: [],
    };
  },
  mounted() {
    this.$on('refresh-grid', () => {
      this.loadItems();
    })
  },
  methods: {
    toggleAllCheckboxes: function (checked) {
      this.selectedRows = [];
      if (checked) {
        let _that = this;
        this.items.forEach((value) => {
          _that.selectedRows.push(value.id);
        })
      }
    },
    goTo(item) {
      this.$router.push({name: 'dictionary-entry', params: {entry: item.alias}});
    },
    edit(item) {
      this.$router.push({name: 'dictionary-entry', params: {entry: item.alias}});
    },
    deleteItem: function (item) {
      let _that = this;
      let url = null;

      if (item.isActive) {
        url = `/api/purchase/fun-coin-package/${item.id}/disable`
      } else {
        url = `/api/purchase/fun-coin-package/${item.id}/enable`
      }

      this.$bvModal.msgBoxConfirm( item.name, {
        title: item.isActive ? this.$t('modal.title.disable_package') : this.$t('modal.title.enable_package'),
        okTitle: item.isActive ? this.$t('btn.disable') : this.$t('btn.enable'),
        cancelTitle: this.$t('btn.cancel'),
        okVariant: item.isActive ? 'danger' : 'success',
      })
          .then(value => {
            if (value) {
              axios.post(url)
                  .then(function () {
                    _that.loadItems();
                  })
                  .catch(error => {
                    console.log(error);
                  });
            }
          });
    },
    addNew() {
      const
          ModalConstructor = Vue.extend(PackageAddModal),
          modal = new ModalConstructor({parent: this});

      modal.name = 'edit-dict';
      modal.title = this.$t('modal.title.new_freecoin_package');

      modal.$mount();
    },
    createFilterQuery() {
      let filter = '';
      Object.keys(this.filterQuery).forEach(key => {
        filter += this.filterQuery[key];
        if (key === 'name') {
          filter += '&filters[name][0][operator]=like'
        }
      })

      return filter;
    },
  },
  watch: {
  }
}
</script>
